import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RequestStatus, CreateRequestStatusDto, UpdateRequestStatusDto } from '../models/request-status.model';

export interface IAuthUser {
    org: string;
}

@Injectable({
    providedIn: 'root',
})
export class RequestStatusService {
    private baseUrl = `${environment.API_GATEWAY_URL}/request-v2/admin/request-status`;

    constructor(private http: HttpClient) {}

    getDefaultStatusList(): Observable<RequestStatus[]> {
        return this.http.get<RequestStatus[]>(`${this.baseUrl}/default-status`);
    }

    getAllAvailableToOrg(raw: boolean = false): Observable<RequestStatus[]> {
        return this.http.get<RequestStatus[]>(`${this.baseUrl}?raw=${raw}`);
    }

    getAllCreatedByOrg(): Observable<RequestStatus[]> {
        return this.http.get<RequestStatus[]>(`${this.baseUrl}/created`);
    }

    findById(id: string): Observable<RequestStatus> {
        return this.http.get<RequestStatus>(`${this.baseUrl}/${id}`);
    }

    create(statusData: CreateRequestStatusDto): Observable<RequestStatus> {
        return this.http.post<RequestStatus>(this.baseUrl, statusData);
    }

    update(id: string, statusData: UpdateRequestStatusDto): Observable<RequestStatus> {
        return this.http.patch<RequestStatus>(`${this.baseUrl}/${id}`, statusData);
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }

    getStatusEdition(id: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/${id}/edition`);
    }

    migrateStatus(id: string, newStatusId: string): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/${id}/migration`, { newStatusId });
    }
}
